/**
 * Created by JIocb on 27.06.2017.
 */
namespace Factive.Game {
    import DependenciesContainer = Factive.Core.DependenciesContainer;
    import Armature = dragonBones.Armature;
    import Slot = dragonBones.Slot;
    import LocalizationManager = Arkadium.Core.utils.LocalizationManager;
    import LocalizationConstants = Arkadium.Game.Localization.LocalizationConstants;

    export class ScoreTableRowHintView extends PIXI.Container
    {
        private _dc: Factive.Core.DependenciesContainer;
        private _lm: LocalizationManager;
        private _back:PIXI.DisplayObject;

        constructor(dc: DependenciesContainer) {
            super();
            this._dc = dc;
            this._lm = this._dc.get("LocalizationManager");
        }

        public initialize(scoreCombination:number,aspectRatio:string):void
        {
            this.clear();

            let assetScale = this._dc.get("AssetScale");

            let armatureName:string = (scoreCombination < 6) ? "HintShort" : "HintBig";
            let armature:Armature = dragonBones.PixiFactory.factory.buildArmature(armatureName);
            this.addChild(<PIXI.DisplayObject>armature.display);
            this._back = <PIXI.DisplayObject>armature.getSlot("Back").display;

            if(aspectRatio == "portrait")
            {
                this._back.scale.x = -1;
            }
            else
            {
                this._back.scale.x = 1;
            }

            let pixiText:PIXI.Text = new PIXI.Text("", <PIXI.TextStyle>{
                fontFamily:'Bold',
                fontSize:12* assetScale,
                fill:'#000000',
                align:"center",
                wordWrap:true,
                wordWrapWidth:((scoreCombination < 6)?120 :160) * assetScale
            });



            pixiText.text = this.getHintTextById(scoreCombination);
            pixiText.anchor.set(0.5, 0.5);
            let slot:Slot = armature.getSlot("hint_text");
            slot.display = pixiText;
            slot.display.x += (scoreCombination < 6)?Math.floor(6 * assetScale) :Math.floor(12 * assetScale);
            //pixiText.scale.x = pixiText.scale.y = 0.5;

            slot = armature.getSlot("hint_dices");
            if(slot)
            {
                let armatureName:string = this.getHintDicesById(scoreCombination);
                let arm:Armature = dragonBones.PixiFactory.factory.buildArmature(armatureName);
                slot.display = arm.display;
                slot.display.x += Math.floor(15* assetScale);
            }
        }

        private getHintTextById(id:number):string
        {
            let text:string;
            let key:string;

            switch(id)
            {
                case 0:
                    key = LocalizationConstants.HINT_UP_ALL_THE_1S;
                    break;
                case 1:
                    key = LocalizationConstants.HINT_UP_ALL_THE_2S;
                    break;
                case 2:
                    key = LocalizationConstants.HINT_UP_ALL_THE_3S;
                    break;
                case 3:
                    key = LocalizationConstants.HINT_UP_ALL_THE_4S;
                    break;
                case 4:
                    key = LocalizationConstants.HINT_UP_ALL_THE_5S;
                    break;
                case 5:
                    key = LocalizationConstants.HINT_UP_ALL_THE_6S;
                    break;
                case 6:
                    key = LocalizationConstants.HINT_3_OF_A_KIND;
                    break;
                case 7:
                    key = LocalizationConstants.HINT_4_OF_A_KIND;
                    break;
                case 8:
                    key = LocalizationConstants.HINT_5_OF_A_KIND;
                    break;
                case 9:
                    key = LocalizationConstants.HINT_FULL_HOUSE;
                    break;
                case 10:
                    key = LocalizationConstants.HINT_SM_STRAIGHT;
                    break;
                case 11:
                    key = LocalizationConstants.HINT_LG_STRAIGHT;
                    break;
                case 12:
                    key = LocalizationConstants.HINT_CHANCES;
                    break;
            }

            text = this._lm.getText(key);

            return text;
        }

        private getHintDicesById(id:number):string
        {
            let key:string;

            switch(id)
            {
                case 6:
                    key = "HintDices_3_OfAKind";
                    break;
                case 7:
                    key = "HintDices_4_OfAKind";
                    break;
                case 8:
                    key = "HintDices_5_OfAKind";
                    break;
                case 9:
                    key = "HintDicesFullHouse";
                    break;
                case 10:
                    key = "HintDicesSmStraight";
                    break;
                case 11:
                    key = "HintDicesLgStraight";
                    break;
                case 12:
                    key = "HintDicesChance";
                    break;
            }

            return key;
        }

        private clear():void
        {
            if(this._back)
            {
                this.removeChild(this._back);
                this._back = null;
            }
        }

        public destroy():void
        {
            this._dc = null;
            this._lm = null;
            this.removeChild(this._back);
            this._back = null;
            this.removeChildren();
        }
    }
}


// WEBPACK FOOTER //
// src/typescript/Game/Engine/View/ScoreTableRowHintView.ts